var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5479 9.92991L9.93578 15.5415C9.79047 15.6869 9.61796 15.8022 9.42808 15.8808C9.2382 15.9595 9.03468 16 8.82915 16C8.62362 16 8.42009 15.9595 8.23021 15.8808C8.04033 15.8022 7.86781 15.6869 7.7225 15.5415L1 8.82647V1H8.82594L15.549 7.7225C15.8403 8.016 16.0038 8.41285 16.0036 8.82642C16.0034 9.23999 15.8396 9.63669 15.5479 9.92991Z",
    stroke: "#BACAD6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.91131,
    cy: 4.91326,
    r: 0.79998,
    fill: "#486F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/Sales-icon.ce75b9ad79476f6a8951e67478c598fa.svg";
export { ForwardRef as ReactComponent };